export function removeNodesByType(tree, typeIdToRemove) {
    const newTree = JSON.parse(JSON.stringify(tree)); // Deep copy to avoid mutation

    // Step 1: Identify nodes to remove
    const nodesToRemove = new Set();
    for (const key in newTree) {
        if (newTree[key]?.data?.structuralAccountTypeId === typeIdToRemove) {
            nodesToRemove.add(key);
        }
    }

    // Step 2: Remove nodes from the tree
    for (const node of nodesToRemove) {
        delete newTree[node]; // Delete the node
    }

    // Step 3: Remove deleted nodes from parents' children arrays
    for (const key in newTree) {
        if (newTree[key]?.children) {
            newTree[key].children = newTree[key].children.filter(
                (childId) => !nodesToRemove.has(childId) // Keep only non-deleted children
            );
            if (newTree[key].children.length === 0) {
                newTree[key].isFolder = false;
            }
        }
    }

    return newTree;
}
